import axios from "axios";
import config from "../../config.json";

const BASE_URL = config.dev;

const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenLogin");
  if (!token) throw new Error("No authentication token found. Please log in again.");
  return { Authorization: `Bearer ${token}` };
};

export const fetchEventReservations = async ({
  eventId,
  page = 1,
  limit = 50,
  status = "",
  search = "",
  archived = false,
} = {}) => {
  const response = await axios.get(`${BASE_URL}/events/${eventId}/reservations`, {
    params: { page, limit, status, search, ...(archived ? { archived: true } : {}) },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchArchivedEventReservations = async ({
  page = 1,
  limit = 50,
  search = "",
} = {}) => {
  const response = await axios.get(`${BASE_URL}/events/reservations/archived`, {
    params: { page, limit, search },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateEventReservationStatus = async (reservationId, status) => {
  const response = await axios.put(
    `${BASE_URL}/events/reservations/${reservationId}/status`,
    { status },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const updateEventReservationArchive = async (reservationId, archived) => {
  const response = await axios.put(
    `${BASE_URL}/events/reservations/${reservationId}/archive`,
    { archived },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteEventReservation = async (reservationId) => {
  const response = await axios.delete(`${BASE_URL}/events/reservations/${reservationId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
